var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { anythingToString } from '@hawkins/helpers';
import { spacings } from '@hawkins/variables';
import { Chip } from '../../../chip';
import { Text } from '../../../text';
import { DEFAULT_GET_OPTION_LABEL, DEFAULT_GET_OPTION_VALUE, DropdownTestIds } from '../../dropdown.constants';
var displayName = 'DropdownMultiInputLabel';
/**
 * Default component for multi-dropdown label, it will be able to overwrite the chips
 * component if the user provides DropdownMultiInputChip as a prop
 * @param props
 * @returns
 */
export function DropdownMultiInputLabel(props) {
    var _a = props.DropdownMultiExcessCount, DropdownMultiExcessCount = _a === void 0 ? Chip : _a, _b = props.DropdownMultiInputChip, DropdownMultiInputChip = _b === void 0 ? Chip : _b, allowSingleOptionRemoval = props.allowSingleOptionRemoval, className = props.className, classes = props.classes, _c = props.compact, compact = _c === void 0 ? false : _c, disabled = props.disabled, _d = props.getOptionLabel, getOptionLabel = _d === void 0 ? DEFAULT_GET_OPTION_LABEL : _d, _e = props.getOptionValue, getOptionValue = _e === void 0 ? DEFAULT_GET_OPTION_VALUE : _e, _f = props.maxChips, maxChips = _f === void 0 ? 1 : _f, _g = props.multiline, multiline = _g === void 0 ? false : _g, onDeleteOption = props.onDeleteOption, option = props.option, _h = props.placeholder, placeholder = _h === void 0 ? 'Select item' : _h, query = props.query, selected = props.selected;
    var computedValue = query;
    if (computedValue === undefined) {
        computedValue = option === null || option === void 0 ? void 0 : option.label;
    }
    var selectedLength = (selected && selected.length) || 0;
    var hasSelectedItems = (selected && selectedLength > 0) || false;
    var hasValue = computedValue !== undefined;
    var count = selected ? (selected === null || selected === void 0 ? void 0 : selected.length) - maxChips : 0;
    var showExcessCount = selected ? selectedLength > maxChips : false;
    var inputLabel = option ? getOptionLabel(option) : placeholder;
    if (!hasSelectedItems) {
        return (_jsx(Text, __assign({ variant: "body", colorVariant: hasValue ? 'default' : 'faded' }, { children: inputLabel })));
    }
    var chipClasses = {
        withStartAdornment: classes.startAdornmentContainer,
        root: classes.chipsContainer,
        deleteIcon: disabled ? classes.multiLabelChipClearIconDisabled : classes.multiLabelChipClearIcon,
    };
    var dropdownLabelContainerClassName = clsx(className, classes.labelContainerMulti, {
        hasValue: hasSelectedItems,
        multiline: multiline,
    });
    if (!multiline && hasSelectedItems && option) {
        var chips = [];
        var size = selectedLength > maxChips ? maxChips : selectedLength;
        var _loop_1 = function (i) {
            if (selected && selected[i]) {
                chips.push(_jsx(DropdownMultiInputChip, __assign({ option: selected[i], classes: chipClasses, onDelete: allowSingleOptionRemoval && selected
                        ? function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            onDeleteOption && onDeleteOption(selected[i]);
                        }
                        : undefined, deleteButtonProps: { disabled: disabled }, compact: compact, "data-hawkins-style": "Hawkins-Dropdown-startAdornmentContainer, Hawkins-Dropdown-chipsContainer, Hawkins-Dropdown-multiLabelChipClearButton", "data-testid": "".concat(DropdownTestIds.SELECTED_CHIP, "-").concat(i), style: { marginLeft: i === 0 ? 0 : spacings.space0 } }, { children: getOptionLabel(selected[i]) }), "chip-".concat(i)));
            }
        };
        for (var i = 0; i < size; i++) {
            _loop_1(i);
        }
        return (_jsxs("div", __assign({ className: dropdownLabelContainerClassName, "data-hawkins-style": "Hawkins-DropdownLabel-labelContainerMulti, Hawkins-DropdownLabel-labelContainerMulti.hasValue" }, { children: [chips, showExcessCount && (_jsx(DropdownMultiExcessCount, __assign({ count: count, classes: __assign(__assign({}, chipClasses), { label: classes.chipsLabelWithoutTruncation }), compact: compact, "data-testid": DropdownTestIds.SELECTED_HIDDEN_COUNT, style: { marginLeft: spacings.space0 } }, { children: "+".concat(count) })))] })));
    }
    return (_jsx("div", __assign({ className: dropdownLabelContainerClassName, "data-hawkins-style": "Hawkins-DropdownLabel-labelContainerMulti, Hawkins-DropdownLabel-labelContainerMulti.hasValue" }, { children: multiline &&
            (selected === null || selected === void 0 ? void 0 : selected.map(function (option, idx) {
                return (_jsx(DropdownMultiInputChip, __assign({ "data-testid": "".concat(DropdownTestIds.SELECTED_CHIP, "-").concat(idx), option: option, classes: chipClasses, onDelete: allowSingleOptionRemoval
                        ? function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            onDeleteOption && onDeleteOption(option);
                        }
                        : undefined, deleteButtonProps: { disabled: disabled }, compact: compact }, { children: getOptionLabel(option) }), anythingToString(getOptionValue(option))));
            })) })));
}
DropdownMultiInputLabel.displayName = displayName;
